export * from './Highlight';
export { extractHighlights, highlight } from './util/highlight';
